/* eslint-disable @typescript-eslint/no-non-null-assertion */

import { Application, Partner, PersonRoleEnum } from 'models/extension-generated';
import { getFirstOfNextMonth } from './dates';
import { getStringUuid } from '@portal/ui-library';

export function createApplication(): Application {
  return {
    applicationStart: getFirstOfNextMonth(),
    inSignSessionId: '',
    partners: [
      createApplicationPartner([PersonRoleEnum.INSURED_PERSON], 1),
      createApplicationPartner([PersonRoleEnum.POLICY_HOLDER], 2),
      createApplicationPartner([PersonRoleEnum.PAYMENT_CONTRIBUTOR], 3)
    ]
  };
}

export function createApplicationPartner(
  roles: Array<PersonRoleEnum>,
  order: number,
  id?: string
): Partner {
  return {
    id: id || getStringUuid(),
    order,
    birthDate: '',
    firstname: '',
    lastname: '',
    roles,
    salutation: undefined!,
    livingInGermany: undefined!,
    gender: undefined!,
    permanentResidence: {
      street: '',
      houseNumber: '',
      postalCode: '',
      city: ''
    },
    bankDetails: {
      bankName: undefined!,
      bicNumber: undefined!,
      iban: undefined!,
      hasPaymentAuthorization: null!
    },
    applicationInformation: {
      health: [],
      employer: '',
      employmentGroup: null!,
      hasInsolvency: null!,
      hasInsuranceDept: null!,
      hasLegalObligationToNotify: null!,
      hasUsedEmergencyTariff: null!,
      profession: null!
    }
  };
}
